import { useReducer as useReactReducer } from 'react'

export const useReducer = useReactReducer

export default useReducer
